import { render, staticRenderFns } from "./NotificationHistory.vue?vue&type=template&id=e94c0010"
import script from "./NotificationHistory.vue?vue&type=script&lang=js"
export * from "./NotificationHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e94c0010')) {
      api.createRecord('e94c0010', component.options)
    } else {
      api.reload('e94c0010', component.options)
    }
    module.hot.accept("./NotificationHistory.vue?vue&type=template&id=e94c0010", function () {
      api.rerender('e94c0010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/term/NotificationHistory.vue"
export default component.exports